import React, { useState } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

function ProductModal({ product, isOpen, onClose, onAddToCart }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!isOpen || !product) return null;

  const images = product.images && product.images.length > 0 ? product.images : [];
  const hasMultipleImages = images.length > 1;

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleAddToCart = () => {
    onAddToCart(product);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content product-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="product-modal-grid">
          <div className="product-modal-images">
            {images.length > 0 ? (
              <>
                <div className="main-image">
                  <img src={images[currentImageIndex]} alt={product.name} />
                  {hasMultipleImages && (
                    <>
                      <button className="image-nav prev" onClick={prevImage}>
                        <FaChevronLeft />
                      </button>
                      <button className="image-nav next" onClick={nextImage}>
                        <FaChevronRight />
                      </button>
                    </>
                  )}
                </div>
                {hasMultipleImages && (
                  <div className="image-thumbnails">
                    {images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`${product.name} ${index + 1}`}
                        className={index === currentImageIndex ? 'active' : ''}
                        onClick={() => setCurrentImageIndex(index)}
                      />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div className="product-placeholder-modal">🌿</div>
            )}
          </div>

          <div className="product-modal-info">
            <h2>{product.name}</h2>
            <div className="product-modal-price">{product.price}</div>

            {product.composition && (
              <div className="product-detail">
                <strong>Состав:</strong>
                <p>{product.composition}</p>
              </div>
            )}

            {product.weight && (
              <div className="product-detail">
                <strong>Вес:</strong>
                <p>{product.weight}</p>
              </div>
            )}

            {product.description && (
              <div className="product-detail">
                <strong>Описание:</strong>
                <p>{product.description}</p>
              </div>
            )}

            {product.shelfLife && (
              <div className="product-detail">
                <strong>Срок годности:</strong>
                <p>{product.shelfLife}</p>
              </div>
            )}

            {product.storage && (
              <div className="product-detail">
                <strong>Условия хранения:</strong>
                <p>{product.storage}</p>
              </div>
            )}

            <button
              className="add-to-cart-btn modal-cart-btn"
              onClick={handleAddToCart}
              disabled={!product.stock || product.stock === 0}
            >
              {!product.stock || product.stock === 0 ? 'Нет в наличии' : 'Добавить в корзину'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductModal;
